"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = reducer;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const initialFromDate = () => {
    const currentDate = new Date();
    return new Date(currentDate.getFullYear() - 1, currentDate.getMonth(), currentDate.getDate() + 1)
        .toISOString()
        .split("T")[0];
};
const initialState = {
    ui: {
        productId: "",
        productPropertyFilter: "",
        operatingCaseResultsPropertyFilter: "",
        properties: "",
        resultProperties: "",
        fromDate: initialFromDate(),
        toDate: new Date().toISOString().split("T")[0]
    },
    query: {
        productId: "",
        productPropertyFilter: "",
        operatingCaseResultsPropertyFilter: "",
        properties: [],
        resultProperties: [],
        fromDate: "",
        toDate: ""
    },
    showResults: false,
    currentPage: 1,
    sorting: {}
};
function reducer(state = initialState, action) {
    switch (action.type) {
        case "advanced-product-search/SET-UI":
            return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { [action.payload.propertyName]: action.payload.value }) });
        case "advanced-product-search/SEARCH":
            return Object.assign(Object.assign({}, state), { query: Object.assign(Object.assign({}, state.ui), { properties: state.ui.properties === "" ? [] : state.ui.properties.split(","), resultProperties: state.ui.resultProperties === ""
                        ? []
                        : state.ui.resultProperties.split(",") }), showResults: true, sorting: {}, currentPage: 1 });
        case "advanced-product-search/CLEAR":
            return Object.assign(Object.assign({}, state), { showResults: false, sorting: {}, currentPage: 1 });
        case "advanced-product-search/SET-PAGE":
            return Object.assign(Object.assign({}, state), { currentPage: action.payload.page });
        case "advanced-product-search/SET-SORT-COLUMN":
            return Object.assign(Object.assign({}, state), { sorting: {
                    column: {
                        name: action.payload.columnName,
                        ascending: !(state.sorting.column &&
                            state.sorting.column.name === action.payload.columnName &&
                            state.sorting.column.ascending)
                    }
                }, currentPage: 1 });
        case "advanced-product-search/SET-RESULT-PROPERTY-SORT-COLUMN":
            return Object.assign(Object.assign({}, state), { sorting: {
                    property: {
                        name: action.payload.propertyName,
                        ascending: !(state.sorting.property &&
                            state.sorting.property.name === action.payload.propertyName &&
                            state.sorting.property.ascending)
                    }
                }, currentPage: 1 });
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
            return state;
    }
}
//# sourceMappingURL=reducer.js.map